import { __rest, __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { Wrapper, Icon } from './styles.js';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { FormControlLabel, Typography } from '@mui/material';

function ZigCheckBox(_a) {
    var _b = _a.variant, variant = _b === void 0 ? "contained" : _b, label = _a.label, id = _a.id, wrapperSx = _a.wrapperSx, props = __rest(_a, ["variant", "label", "id", "wrapperSx"]);
    return (React__default.createElement(FormControlLabel, { id: id, sx: wrapperSx, control: React__default.createElement(Checkbox, __assign({}, props, { id: id && "".concat(id, "-input"), sx: __assign(__assign({}, (props.disabled
                ? {
                    opacity: 0.5,
                    cursor: "not-allowed",
                }
                : {})), props.sx), checkedIcon: variant === "outlined" ? (React__default.createElement(Wrapper, null,
                React__default.createElement(Icon, null))) : (React__default.createElement(CheckBoxIcon, null)), icon: variant === "outlined" ? React__default.createElement(Wrapper, null) : React__default.createElement(CheckBoxOutlineBlankIcon, null) })), label: variant === "outlined"
            ? label && (React__default.createElement(Typography, { variant: "body2", color: "neutral300", id: id && "".concat(id, "-label") }, label))
            : label }));
}

export { ZigCheckBox as default };
